var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { IMAGE_MAP, getAssetUrl } from '../../../const/imageRoutes';
import styled from 'styled-components';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
var ImageContainerWidth = {
    small: '168px',
    medium: '216px',
    xsmall: '144px',
    xxsmall: '94px',
    icon: '24px'
};
var ImageContainerHeight = {
    small: '112px',
    medium: '144px',
    xsmall: '96px',
    xxsmall: '64px',
    icon: '24px'
};
var Image = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  object-fit: contain;\n  height: 100%;\n  width: 100%;\n"], ["\n  object-fit: contain;\n  height: 100%;\n  width: 100%;\n"])));
var ImageContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n"], ["\n  height: ", ";\n  width: ", ";\n"])), function (props) { return ImageContainerHeight[props.$size]; }, function (props) { return ImageContainerWidth[props.$size]; });
var DisputesImage = function (_a) {
    var alt = _a.alt, assetsHost = _a.assetsHost, className = _a.className, imageName = _a.imageName, size = _a.size;
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    var fileName = IMAGE_MAP[imageName];
    var devicePath = isLessThanTablet ? 'mobile/' : 'desktop/';
    var sourceName = "".concat(getAssetUrl(assetsHost)).concat(devicePath).concat(fileName);
    return (_jsx(ImageContainer, __assign({ className: className, "$size": size }, { children: _jsx(Image, { alt: alt, "aria-hidden": "true", "data-testid": "disputes-image", src: sourceName }) })));
};
export default DisputesImage;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map